import { createSlice } from '@reduxjs/toolkit';
import {
  SponsorOverviewFiltersState,
  SponsorOverviewFiltersToggleActiveFiltersAction,
  SponsorOverviewFiltersToggleSelectedFiltersAction,
  FilterItemType,
  NestedFilterItemsType,
} from './sponsorOverviewFilters.types';
import { createSliceHook, makeActionCreator } from '../helpers';
import { RootState } from '../store';
import { toggleFilterState } from '../usersFilters/toggleFilterState';

const initialState: SponsorOverviewFiltersState = {
  selectedFilters: {
    siteId: [],
    visitId: [],
  },
  allFilters: {
    siteId: [],
    visitId: [],
  },
  state: {
    siteId: {
      active: false,
      label: 'Site Code',
    },
    visitId: {
      active: false,
      label: 'Visit Name',
    },
  },
};

const { act } = makeActionCreator<SponsorOverviewFiltersState>();

export const sponsorOverviewFiltersSlice = createSlice({
  name: 'sponsorOverviewFilters',
  initialState,
  reducers: {
    toggleActiveFilters: (
      filterSliceState,
      action: SponsorOverviewFiltersToggleActiveFiltersAction
    ) => toggleFilterState(filterSliceState, action.payload),

    toggleSelectedFilters: act<
      SponsorOverviewFiltersToggleSelectedFiltersAction['payload']
    >(({ name, value }, { selectedFilters }) => ({
      selectedFilters: {
        ...selectedFilters,
        [name]: selectedFilters[name]?.includes(value) ? [] : [value],
      },
    })),
    setNestedFilters: act<{
      key: string;
      value: FilterItemType[] | NestedFilterItemsType[];
    }>(({ key, value }, { allFilters }) => {
      return {
        allFilters: {
          ...allFilters,
          [key]: value,
        },
      };
    }),
    reset: () => {
      return initialState;
    },
  },
});

export const { toggleActiveFilters, reset } =
  sponsorOverviewFiltersSlice.actions;

export const actions = {
  ...sponsorOverviewFiltersSlice.actions,
};

export const useSponsorOverviewFiltersSlice = createSliceHook(
  sponsorOverviewFiltersSlice.name,
  actions
);

export const sponsorOverviewFiltersState = (root: RootState) =>
  root.sponsorOverviewFilters;
